<div class="hero-banner">
  <p class="hero-banner__title">{{heroTitle}}</p>
  <img class="hero-banner__image" [src]="heroImage" alt="image">
  <div class="hero-banner__message">
    <p><b>{{messageTitle}}</b></p>
    <p>{{messageBody}}</p>
    <p *ngIf="warningMessage" class="hero-banner__message hero-banner__message_warning">{{warningMessage}}</p>
  </div>
</div>
